
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Reims dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Reims certifiée Google Partner, aide les entreprises rémoises à élargir leur audience et booster leur chiffre d'affaires.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Reims dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Reims certifiée Google Partner, aide les entreprises rémoises à élargir leur audience et booster leur chiffre d'affaires.",
        },
      ],
    };
  },
};
